import * as React from "react";

import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";
import { NutritionVitaminB12DiagramContent } from "./NutritionVitaminB12Diagram";
import { NutritionVitaminB12KeyContent } from "./NutritionVitaminB12Key";

const SvgNutritionVitaminB12DiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1344, 1556)}
      viewBox={diagramOnly ? "0 212 1024 1344" : "0 0 1024 1556"}
    >
      <g id="nutrition-vitamin_b12-diagram+key" clipPath="url(#clip0_18284_196589)">
        <rect width={1024} height={diagramOnly ? 1344 : 1556} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <NutritionVitaminB12KeyContent />
          </g>
        )}
        <NutritionVitaminB12DiagramContent
          geneColors={geneColors}
          expectedSnps={expectedSnps}
          onGeneClick={onGeneClick}
        />
      </g>
      <defs>
        <clipPath id="clip0_18284_196589">
          <rect width={1024} height={1556} fill="white" />
        </clipPath>
        <clipPath id="clip1_18284_196589">
          <rect width={1024} height={1344} fill="white" transform="translate(0 212)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgNutritionVitaminB12DiagramKey;
